<template>
    <counsel-card-row label="첨부파일">
        <template v-if="files.length">
            <v-chip-group>
                <v-chip v-for="(file, i) in files" :key="i" :value="file._id" :href="file.url" download> {{ file.fileName }} </v-chip>
            </v-chip-group>
        </template>
        <template v-else>첨부파일이 없습니다.</template>
    </counsel-card-row>
</template>

<script>
import counselCardRow from "./counsel-card-row.vue";
export default {
    components: { counselCardRow },
    props: ["files"],
};
</script>

<style></style>
